module.exports = __webpack_public_path__ + "media/images/auth-side-image-eb72d94a.png";